import { Coupon, CreateCoupon, SimplifiedCoupon, UpdateCoupon } from "../../Models/Coupon";
import api from "../axios";

export const couponService = {
  getAll: async (): Promise<Coupon[]> => {
    const response = await api.get('/coupon');
    return response.data;
  },

  validate: async (code: string): Promise<SimplifiedCoupon> => {
    const response = await api.get(`/coupon/validate?code=${encodeURIComponent(code)}`);
    return response.data;
  },

  create: async (data: CreateCoupon) => {
    const response = await api.post('/coupon', data);
    return response.data;
  },

  update: async (data: UpdateCoupon) => {
    const response = await api.put('/coupon', data);
    return response.data;
  },

  updateStatus: async (id: string, isActive: boolean) => {
    const response = await api.patch(`/coupon/${id}/status`, { isActive });
    return response.data;
  },

  delete: async (id: string) => {
    const response = await api.delete(`/coupon/${id}`);
    return response.data;
  }
};
